module.exports = __webpack_public_path__ + "img/divider.653c27c9.svg";